<div *ngIf="loading" class="d-flex justify-content-center align-items-center py-5">
  <app-spinner></app-spinner>
</div>

<ng-container *ngIf="!loading">
  <div class="tfs">

    <div class="tfs-nav">
      <button class="tfs-quit-btn" (click)="close()">
        <i class="fa-solid fa-arrow-left"></i>
        <span translate>Retour au tableau de bord</span>
      </button>
    </div>

    <div class="tfs-card">

      <div class="tfs-icon">
        <i class="fa-solid fa-graduation-cap"></i>
      </div>

      <div class="tfs-title">{{ state.name }}</div>
      <div class="tfs-subtitle" translate>Évalue le niveau que tu as atteint pendant ta formation</div>

      <div class="tfs-deadline mb-4" *ngIf="deadline && state.status !== 'done'">
        <i class="fa-regular fa-clock"></i>
        <span translate [translateParams]="{ date: (deadline | date:'dd/MM/yyyy') }">assessment.deadline</span>
      </div>

      <!-- Dernière tentative terminée : la plus récente fait foi -->
      <div class="tfs-result mb-4" *ngIf="state.status === 'done'">
        <div class="tfs-result-cefrl" *ngIf="state.lastEstimatedCefrl">
          <span translate>Niveau estimé</span>
          <strong>{{ state.lastEstimatedCefrl }}</strong>
        </div>
        <div class="tfs-result-score">
          <span translate>Dernier score</span> : <strong>{{ state.lastScore }}%</strong>
        </div>
        <div class="tfs-result-date" *ngIf="state.lastDate">
          {{ state.lastDate | date:'dd/MM/yyyy' }}
        </div>
      </div>

      <!-- Tentative en cours -->
      <div class="tfs-in-progress mb-4" *ngIf="state.status === 'in_progress'">
        <i class="fa-solid fa-hourglass-half mr-2"></i>
        <span translate>Tu as une tentative en cours, tu peux la reprendre là où tu t'étais arrêté.e.</span>
      </div>

      <!-- Infos -->
      <div class="tfs-infos mb-3">
        <div class="tfs-info">
          <div class="tfs-info-value">{{ state.questionCount }}</div>
          <div class="tfs-info-label" translate>questions</div>
        </div>
        <div class="tfs-info">
          <div class="tfs-info-value">{{ state.successScore }}%</div>
          <div class="tfs-info-label" translate>pour valider un palier</div>
        </div>
      </div>

      <!-- Composition par palier -->
      <ng-container *ngIf="state.composition?.length">
        <div class="tfs-composition-label" translate>Répartition des questions par palier</div>
        <div class="tfs-composition mb-4">
          <div class="tfs-composition-chip" *ngFor="let item of state.composition; trackBy: trackByIndex">
            <span class="tfs-composition-cefrl">{{ item.cefrl }}</span>
            <span class="tfs-composition-count">{{ item.questions }}</span>
          </div>
        </div>
      </ng-container>

      <!-- Comment ça marche -->
      <div class="tfs-how mb-4">
        <div class="tfs-how-title">
          <i class="fa-solid fa-circle-info"></i>
          <span translate>Comment ça marche ?</span>
        </div>
        <div class="tfs-how-item">
          <i class="fa-solid fa-layer-group"></i>
          <span translate>Le test couvre tous les paliers de ta formation, du premier au dernier.</span>
        </div>
        <div class="tfs-how-item">
          <i class="fa-solid fa-forward"></i>
          <span translate>Une seule question à la fois, sans retour en arrière possible.</span>
        </div>
        <div class="tfs-how-item">
          <i class="fa-solid fa-eye-slash"></i>
          <span translate>Pas de correction pendant le test : tes résultats t'attendent à la fin.</span>
        </div>
        <div class="tfs-how-item">
          <i class="fa-solid fa-rotate-right"></i>
          <span translate>Tu peux le repasser à volonté : la dernière tentative terminée fait foi.</span>
        </div>
      </div>

      <!-- Actions -->
      <div class="tfs-actions">
        <button class="tfs-btn tfs-btn-primary" *ngIf="state.status === 'todo'" (click)="start()" translate>
          Passer le test
        </button>
        <button class="tfs-btn tfs-btn-primary" *ngIf="state.status === 'in_progress'" (click)="start()" translate>
          Reprendre le test
        </button>
        <ng-container *ngIf="state.status === 'done'">
          <button class="tfs-btn tfs-btn-primary" (click)="viewResult()" translate>
            Voir la correction
          </button>
          <button class="tfs-btn tfs-btn-outline" (click)="start()" translate>
            Repasser le test
          </button>
        </ng-container>
      </div>

    </div>

    <!-- Historique des tentatives -->
    <div class="tfs-attempts" *ngIf="state.attempts?.length">
      <div class="tfs-attempts-title" translate>Historique des tentatives</div>
      <div class="tfs-attempt" *ngFor="let attempt of state.attempts; trackBy: trackByIndex">
        <span class="tfs-attempt-date">{{ attempt.date | date:'dd/MM/yyyy' }}</span>
        <span class="tfs-attempt-cefrl" *ngIf="attempt.estimatedCefrl">{{ attempt.estimatedCefrl }}</span>
        <span class="tfs-attempt-cefrl tfs-attempt-cefrl--none" *ngIf="!attempt.estimatedCefrl">—</span>
        <span class="tfs-attempt-time">{{ formatPlayTime(attempt.playTime) }}</span>
        <span class="tfs-attempt-score">{{ attempt.score }}%</span>
      </div>
    </div>

  </div>
</ng-container>
